var getOptions=function getOptions(options,key){return(/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */options[key]?Object.assign(Object.assign({},options),options[key]):Object.assign({},options));};export{getOptions};